import React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';

import { useCurrentTracklog, useDebriefRouter } from 'ff/debrief/hooks';

interface Props {
    shareId: string;
    tracklogId?: string;
}

const LinkToShared = React.forwardRef<
    HTMLAnchorElement,
    React.PropsWithChildren<Props>
>(function LinkToShared(props, ref) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { shareId, tracklogId, ...rest } = props;
    const { tracklog: currentTracklog } = useCurrentTracklog();
    const { getSharedRouteString } = useDebriefRouter();
    const pathString = getSharedRouteString(
        shareId || currentTracklog?.shareDetailsSummary?.shareId
    );
    if (pathString)
        return (
            <UnstyledLink ref={ref} to={pathString} {...rest}>
                {props.children}
            </UnstyledLink>
        );
    else return null;
});

const UnstyledLink = styled(Link)`
    text-decoration: inherit;
    color: inherit;
`;

export default LinkToShared;
